import { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Badge } from "react-bootstrap";
import Select from 'react-select';
import { FaPlus, FaRegEdit } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, tiposServicos } from '../../common/utils';
import Paginacao from '../../common/pagination';
import debounce from 'lodash.debounce';

class Servicos extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onChangeFilterStatus = this.onChangeFilterStatus.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaServico = this.buscaServico.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            page_numb: 1,
            loading: true,
            filterStatus: 'ativo',
        };

        this.debouncedSearch = debounce((busca) => {
            this.setState({ loading: true, page_numb: 1 });
            this.consultaRegistro(busca, 1);
        }, 800);
    }

    componentDidMount(){
        this.consultaRegistro(this.state.busca, this.state.page_numb)
    }

    consultaRegistro(busca, page_numb=1){
        const { filterStatus } = this.state;
        let params = `nome=${busca}&page=${page_numb}`;

        if (filterStatus === 'todos') {
            params += '&is_active=all';
        } else if (filterStatus === 'inativo') {
            params += '&is_active=false';
        } else if (filterStatus === 'ativo') {
            params += '&is_active=true';
        }

        api.get(`/servicos_procedimentos/?${params}`)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar serviços e procedimentos, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    renderRows = () => {
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.nome}</td>
                <td>{tiposServicos[item.tipo]}</td>
                <td>
                    {item.is_active ? 
                        <Badge bg="success">Ativo</Badge> : 
                        <Badge bg="secondary">Inativo</Badge>
                    }
                </td>
                <td>
                    <Button variant="light" href={"/servicos/edit/"+item.id} size="sm">
                        <FaRegEdit /> Editar
                    </Button>    
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={6}>Nenhum serviço ou procedimento cadastrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        const busca = e.target.value;
        this.setState({
            busca: busca
        });
        this.debouncedSearch(busca);
    }

    onChangeFilterStatus(selectedOption) {
        this.setState({
            filterStatus: selectedOption.value,
            loading: true,
            page_numb: 1
        }, () => {
            this.consultaRegistro(this.state.busca, 1);
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistro(this.state.busca, num_page)
    }

    buscaServico(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaRegistro(this.state.busca)
    }

    render() {
        if (!hasPerm('view_servicos_procedimentos')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Serviços e Procedimentos</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/servicos/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Serviço/Procedimento
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <h4>Filtros</h4>
                        <Row className="mb-3">
                            <Col sm={12} md={6} lg={4}>
                                <Form.Group>
                                    <Form.Label>Nome</Form.Label>                                  
                                    <Form.Control
                                        type="text"
                                        name="busca"
                                        value={this.state.busca}
                                        onChange={this.onChangeBusca}
                                        placeholder="Nome do serviço/procedimento"
                                        aria-label="Nome do serviço/procedimento"
                                    />
                                </Form.Group>

                            </Col>
                            <Col sm={3} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Status</Form.Label>
                                    <Select
                                        name="status"
                                        options={[
                                            { value: 'ativo', label: 'Ativo' },
                                            { value: 'todos', label: 'Todos' },
                                            { value: 'inativo', label: 'Inativo' }
                                        ]}
                                        value={{ 
                                            value: this.state.filterStatus, 
                                            label: this.state.filterStatus === 'ativo' ? 'Ativo' : (this.state.filterStatus === 'inativo' ? 'Inativo' : 'Todos') 
                                        }}
                                        onChange={this.onChangeFilterStatus}
                                        aria-label="Status do serviço/procedimento"
                                        placeholder="Selecione o status"
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Tipo</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={6}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={6}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Servicos);
